export default __webpack_public_path__ + "static/environment-272dab9538e0dcc72a17f59bb040ce1d.png";